module.exports = {
  0: { api: 0, human: 'Vermittler' },
  1: { api: 1, human: 'Interessent' },
  2: { api: 2, human: 'Gruppe' },
  3: { api: 3, human: 'Ex-Vermittler' }
}
